const Footer = () => {
	return (
		<div>
			<footer className="mt-5">
				{/* <div className="row  ps-3 mt-5">
					<div className="col-12 col-lg-4">
						<div className="row">
							<div className="col"></div>
						</div>
						<div className="row pt-4"></div>
					</div>
					<div className="col-12 col-lg-1"></div>
					<div className="col-6 col-lg-2 pt-lg-2 pt-0"></div>
					<div className="col-6 col-lg-2 pt-lg-2 pt-0"></div>
					<div className="col-12 col-lg-2 pt-lg-2 pt-0"></div>
				</div>*/}
				<div className="row  pt-3 ps-3">
					<div className="col-4">
						<div className="textwidget"><p>Edificio central IFOP: Almirante Blanco Encalada 839, Valparaíso. Chile.</p></div>
					</div>
				</div>
			</footer>
		</div>
	);
}
export default Footer;